import { useState, useEffect } from 'react';

import { SelectedOptionsTags, Filters, SchemaFilterType } from '../types';

export default function useSelectedTags(
  filters: Filters,
  tableLabels: Record<string, unknown>,
): {
  selectedOptionsTags: SelectedOptionsTags[];
} {
  const [selectedOptionsTags, setSelectedOptionsTags] = useState<
    SelectedOptionsTags[]
  >([]);

  useEffect(() => {
    const nextFilterValues: SelectedOptionsTags[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && key !== 'cursor' && tableLabels[key]) {
        if (value.type === SchemaFilterType.DATE_RANGE) {
          if (value?.value?.length > 1) {
            nextFilterValues.push({
              key,
              value: value.value.join(' - '),
              label: tableLabels[key] as string,
            });
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (Array.isArray(value?.value)) {
            value?.value?.forEach((item) => {
              nextFilterValues.push({
                key,
                value: item,
                label: tableLabels[key] as string,
              });
            });
          } else {
            nextFilterValues.push({
              key,
              value: value?.value,
              label: tableLabels[key] as string,
            });
          }
        }
      }
    });

    setSelectedOptionsTags(nextFilterValues);
  }, [filters, setSelectedOptionsTags, tableLabels]);

  return {
    selectedOptionsTags,
  };
}
